export const characterServices = {
  elective: 'Eletivo',
  emergency: 'Urgência/Emergência',
};

export function getName(value) {
  return characterServices[value];
}
